//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[],[[["numContents"],"GetContentOrder",{R_:{contentOrder:""}},0,0],[["contentOrder"],"SetContentOrder",{},1,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.HoleTableSettingsContentBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.HoleTableSettingsContentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.HoleTableSettingsContentBuilder.Content = Object.freeze({
    "Diameter" : "Diameter", "DiameterFit" : "DiameterFit", "Depth" : "Depth", "DepthFit" : "DepthFit", "DrillType" : "DrillType", "DrillDirection" : "DrillDirection"});

export default SPLM;